@if (popoverTemplate(); as popoverTemplate) {
  <a
    [attr.data-cy]="'help-popover'"
    [class]="buttonClass()"
    class="btn btn-outline-link btn-popover"
    [placement]="placement()"
    [container]="container()"
    [containerClass]="containerClass()"
    [popover]="popoverTemplate"
    [outsideClick]="true">
    <i class="fa fa-question-circle fa-color-blue m-1"></i>
  </a>
}
